import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sala-filter"
// Filtra las columnas del programa por salas: "Todas las salas" muestra todas,
// cada pestaña de sala muestra solo esa columna.
export default class extends Controller {
  static targets = ['tab', 'column']

  filter (event) {
    const sala = event.currentTarget.dataset.sala

    this.tabTargets.forEach(tab => {
      tab.setAttribute('aria-selected', tab.dataset.sala === sala)
    })

    this.columnTargets.forEach(column => {
      const visible = sala === 'all' || column.dataset.sala === sala
      column.toggleAttribute('hidden', !visible)
    })
  }
}
